/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React, { useEffect, useState } from 'react'
import Navbar from 'react-bootstrap/Navbar'
import { background, Link } from '@chakra-ui/react'
import { Link as ReachLink } from 'react-router-dom'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'

import { useIsAuthenticated } from '@azure/msal-react'
import { SignInButton } from '../components/SignInButton'
import { SignOutButton } from '../components/SignOutButton'


interface Props {
    children :any
}

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props 
 */
export const PageLayout = ({ children }: Props) => {
	const isAuthenticated = useIsAuthenticated()
	const [initialPageIndex, setInitialPageIndex] = useState<number>(0)

	const contentStyles = {
		padding: 20,
		backgroundColor: 'rgb(248,248,248)',
	}

	const navBarStyles = {
		backgroundColor: 'white',
	}

	function getTabIndex() {

		if(window.location.pathname.startsWith('/alerts/')) {
			return 3
		}

		console.log(window.location.pathname)

		// Otherwise, check for exact match
		switch (window.location.pathname) {
			case '/':
				return 0
			case '/coverage':
				return 1
			case '/attack':
				return 2
			case '/alerts':
				return 3
		}
	}

	return (
		<>
			<Tabs style={navBarStyles} defaultIndex={getTabIndex()}>
				<TabList>
					<Link as={ReachLink} to='/'> <Tab>Home</Tab> </Link>
					{/*<Link as={ReachLink } to='/schedules'> <Tab>Schedules</Tab> </Link>*/}
					<Link as={ReachLink} to='/coverage'> <Tab>Coverage Matrix</Tab> </Link>
					<Link as={ReachLink} to='/attack'> <Tab>Attack Matrix</Tab> </Link>
					<Link as={ReachLink} to='/alerts'> <Tab>Alerts</Tab> </Link>
					{/*<Link as={ReachLink} to='/failedRuns'> <Tab>Failed Runs</Tab> </Link>*/}
				</TabList>
			</Tabs>
			<div style={contentStyles} >{children}</div>
		</>
	)

	/*return (
        <>
            <Navbar bg="primary" variant="dark">
                <a className="navbar-brand" href="/">Farcaster</a>
                { isAuthenticated ? <SignOutButton /> : <SignInButton /> }
            </Navbar>
            <h5>Welcome to the Microsoft Authentication Library For Javascript - React Quickstart</h5>
            <br />
            <br />
            {children}
        </>
    );*/
}

// function _onLinkClick(ev?: React.MouseEvent<HTMLElement>, item?: INavLink) {
//     if (item && item.name === 'News') {
//       alert('News link clicked');
//     }
// }
